import React from 'react';
import GlassView from './GlassView'
import { isPresentInArray } from '../../../../../itrust_common/components/HelperFunctions';

let CurrentGlass = props => {
  const { fieldsValues, template, handleIdsSelect, selectedIds, overviewName } = props;
  return (
    <div className="row">
      {Object.keys(fieldsValues).map((currentGlass, index) =>
        fieldsValues[index].is_marked_complete && <div className={`col-12 ${index !== 0 ? "py-4" : "pb-4"}`}>
          <div className='d-flex justify-content-between'>
            <span>
              Current Glass #{index + 1}
            </span>
            {overviewName && <div className='d-flex'>
              <label className='mr-3'>Select</label>
              <div className="custom-control custom-checkbox">
                <input
                  onChange={() => handleIdsSelect(selectedIds, fieldsValues[index].id)}
                  type="checkbox"
                  checked={isPresentInArray(selectedIds, fieldsValues[index].id)}
                  className="custom-control-input" id={`impression-select-${fieldsValues[index].id}`} />
                <label className="custom-control-label" htmlFor={`impression-select-${fieldsValues[index].id}`}></label>
              </div>
            </div>}
          </div>
          <GlassView
            fieldsValues={fieldsValues[index]}
            template={template.tests[0]}
          />
        </div>
      )}
    </div>
  )
}


export default CurrentGlass;